import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    marginTop: 10,
    width: '90%',
    alignItems: 'flex-end',
    borderWidth: 1,
    borderRadius: 8,
    borderColor: '#dbdbdb',
    marginBottom: 24
  },
  mainTitle: {
    fontSize: 10,
    marginRight: 3,
    backgroundColor: '000'
  },
  singleParagraph: {
    width: '100%',
    marginVertical: 5,
    paddingRight: 10,
    borderStyle: 'solid',
    borderColor: '#dbdbdb',
    alignItems: 'flex-end',
    paddingBottom: 5,
    textAlign: 'right',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start'
  },
  singleParagraphShort: {
    width: '100%',
    marginVertical: -10,
    paddingRight: 10,
    paddingLeft: 10,
    borderStyle: 'solid',
    borderColor: '#dbdbdb',
    alignItems: 'flex-end',
    paddingBottom: 20,
    textAlign: 'right',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start'
  },
  title: {
    fontSize: 10,
    color: '#000',
    fontWeight: 'bold',
    flexDirection: 'row-reverse'
  },
  description: {
    fontSize: 9,
    textAlign: 'right',
    color: '#252525',
    flexDirection: 'row-reverse'
  },
  // Pieces sit side by side in a row; spaces at the edge of a Text are dropped, so the
  // gap between them is a margin.
  piece: {
    marginLeft: 3
  },
  titleContainer: {
    flexDirection: 'row',
    backgroundColor: '#fff',
    paddingHorizontal: 10,
    right: -12,
    top: -24
  }
})

export default styles
